import { useContext, useState } from "react";
import Packages from "../assets/images/packages.png";
import { Box, Card, CardContent, Grid, Link, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AppContext, { AppContextInterface } from "../contexts/AppContext";
import axios from "axios";
import Config from "../config/Config";
import { configAPIHeaders } from "../services/api";
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
import LoadingButton from "@mui/lab/LoadingButton";

const Login = (props) => {
	const appContext = useContext(AppContext);

	const notyf = new Notyf();
	
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");

	const navigation = useNavigate();

	const [loadingLogin, setLoadingLogin] = useState<boolean>(false);

	const onChangeUsername = (e) => {
		const username = e.target.value;
		setUsername(username);
	};

	const onChangePassword = (e) => {
		const password = e.target.value;
		setPassword(password);
	};

	const login = async (context: AppContextInterface, email: string, password: string) => {
		setLoadingLogin(true);
		try {
			// await axios.post(Config.BASE_URL_API + "/user/auth", {
			// await axios.post(Config.BASE_URL_API_BUSINESS + "/api/auth/signin", {
			await axios.post(Config.BASE_URL_API_PUBLIC + "/auth/login", {
				email: email,
				password: password
			})
			.then(async response => {
				if (response.status === 200){
					if (response.data.accessToken !== undefined){
						configAPIHeaders(context, response.data.accessToken, response.data.id);
						context.setTokenValue(response.data.accessToken);
						context.setUserEmailValue(response.data.email);
						context.setUserIDValue(response.data.id);
						localStorage.setItem("token", response.data.accessToken);
						localStorage.setItem("email", response.data.email);
						localStorage.setItem("userID", response.data.id);	
						// setLoadingLogin(false);
						// setInterval(() => {
							navigation("/orders");
						// }, 500);
					} else {
						setLoadingLogin(false);
						navigation("/login");
					}
				} else if (response.status === 202){
					setLoadingLogin(false);
					// setInterval(() => {
						navigation("/login");
					// }, 500);
				} else {
					notyf.error('Credenciais inválidas. Tente novamente.');
					setLoadingLogin(false);
					// setInterval(() => {
						navigation("/login");
					// }, 500);
				}
				
			}).catch((error) => {
				notyf.error('Credenciais inválidas. Tente novamente.');
				
				setLoadingLogin(false);
				// setInterval(() => {
					navigation("/login");
				// }, 500);
			});
		} catch (error){
			// console.log(error);
			context.setLoadingLoginValue(false);
			context.setTokenValue(null);
			context.setUserEmailValue(null);
			context.setUserIDValue(null);
			notyf.error('Credenciais inválidas. Tente novamente.');
			// setInterval(() => {
				navigation("/login");
			// }, 500);
		}
	}

	return (
		<>
			<Box>
				<Grid
					container
					style={{
						backgroundImage: "url("+ Packages + ")",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center",
						backgroundSize: "cover"
					}}
				>
					<Grid
						item
						xs={12}
						md={6}
						lg={6}
						
					>
					</Grid>
					<Grid 
						item
						xs={12}
						md={6}
						lg={6}
						style={{
							justifyContent: 'center',
							alignContent: 'center',
							backgroundColor: 'white'
						}}
					>
						<Box display={"flex"} justifyContent="center" alignItems={"center"} alignContent={"center"} alignSelf={"center"} minHeight={"95vh"}>
							<Card
								style={{
									margin: "auto",
									minWidth: 300,
									width: "40vw"
								}}
								elevation={0}
							>
								<CardContent>
									<Typography variant={"caption"} component={"p"}>Leve Aí - Parceiros</Typography>
									<Typography variant={"body1"} component={"p"}>Bem vindo(a) de volta!</Typography>
									<Typography variant={"h4"} component={"h4"} style={{fontWeight: 'bold'}}>Entrar na conta</Typography>
									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"E-mail"}
											placeholder={"Digite o seu e-mail"}
											variant={"outlined"}
											type={"email"}
											value={username}
											onChange={onChangeUsername}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<TextField
											label={"Senha"}
											placeholder={"Digite a sua senha"}
											variant={"outlined"}
											value={password}
											type={"password"}
											onChange={onChangePassword}
											fullWidth
										/>
									</Box>

									<Box
										mt={2}
										mb={2}
									>
										<LoadingButton
											onClick={() => {
												if (appContext){
													setLoadingLogin(true);
													setTimeout(() => {
														login(appContext, username, password)
													}, 1000);
												}
											}}
											variant={"contained"}
											fullWidth
											// style={{
											// 	backgroundColor: green[900],
											// 	color: 'white'
											// }}
											disabled={loadingLogin || password === "" || username === ""}
											loading={loadingLogin}
											color={"primary"}
										>
											Entrar
										</LoadingButton>
									</Box>

									<Box
										textAlign={"center"}
										pt={3}
										pb={3}
									>
										<Link
											component="button"
											variant="body2"
											onClick={() => {
												navigation("/register");
											}}
										>
											Não tem uma conta? Registrar
										</Link>
									</Box>
								</CardContent>
							</Card>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};

export default Login;